function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.805h30v15H0V7.805Z",
    style: {
      fill: "#002395"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95,7.805h15v15L7.95,7.805Z",
    style: {
      fill: "#fecb00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.732 7.805 4.412 8.789 5.25 8.18 6.088 8.789 5.768 7.805 4.732 7.805",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.125 10.055 7.963 10.664 7.643 9.679 8.48 9.07 7.445 9.07 7.125 8.086 6.805 9.07 5.769 9.07 6.607 9.679 6.287 10.664 7.125 10.055",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9 11.93 9.838 12.539 9.518 11.554 10.355 10.945 9.32 10.945 9 9.961 8.68 10.945 7.644 10.945 8.482 11.554 8.162 12.539 9 11.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.875 13.805 11.713 14.414 11.393 13.429 12.23 12.82 11.195 12.82 10.875 11.836 10.555 12.82 9.519 12.82 10.357 13.429 10.037 14.414 10.875 13.805",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.75 15.68 13.588 16.289 13.268 15.304 14.105 14.695 13.07 14.695 12.75 13.711 12.43 14.695 11.394 14.695 12.232 15.304 11.912 16.289 12.75 15.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.625 17.555 15.463 18.164 15.143 17.179 15.98 16.57 14.945 16.57 14.625 15.586 14.305 16.57 13.269 16.57 14.107 17.179 13.787 18.164 14.625 17.555",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.5 19.43 17.338 20.039 17.018 19.054 17.855 18.445 16.82 18.445 16.5 17.461 16.18 18.445 15.144 18.445 15.982 19.054 15.662 20.039 16.5 19.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.375 21.305 19.213 21.914 18.893 20.929 19.73 20.32 18.695 20.32 18.375 19.336 18.055 20.32 17.019 20.32 17.857 20.929 17.537 21.914 18.375 21.305",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.732 22.805 20.768 22.805 20.768 22.804 21.605 22.195 20.57 22.195 20.25 21.211 19.93 22.195 18.894 22.195 19.732 22.804 19.732 22.805",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa);
export default __webpack_public_path__ + "static/media/BA.13557e6db0f8ba12e24a0f63ed467d08.svg";
export { ForwardRef as ReactComponent };